import { clientServicesConfig } from '@audacy-clients/client-services';
import {
  AdTargetingStatusParams,
  AdTargetingStatusResponse,
} from '@audacy-clients/client-services/src/personalizationServices/types';
import { adTargetingState } from '@audacy-clients/core/atoms/adTargeting';
import clientServices from '@audacy-clients/core/utils/clientServices';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';

import Modal from '~/components/Modal';
import Toggle from '~/components/Toggle';
import { setGoogleAdPreferences } from '~/utils/googleAds';

import styles from './styles';

interface IAdPreferencesModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const AdPreferencesModal = ({ isOpen, onClose }: IAdPreferencesModalProps): JSX.Element => {
  const [adTargeting, setAdTargeting] = useRecoilState(adTargetingState);

  const isIneligible = adTargeting === AdTargetingStatusResponse.INELIGIBLE;

  const toggleStatus =
    adTargeting !== AdTargetingStatusResponse.OPT_OUT &&
    adTargeting !== AdTargetingStatusResponse.INELIGIBLE;

  const setLocalAdTargetingStatus = (optIn: boolean): void => {
    const adTargetingStatus = optIn
      ? AdTargetingStatusResponse.OPT_IN
      : AdTargetingStatusResponse.OPT_OUT;
    clientServicesConfig.disableTargetedAds = !optIn;
    setAdTargeting(adTargetingStatus);
  };

  const setAuthenticatedAdTargetingStatus = async (optIn: boolean): Promise<void> => {
    const adTargetingStatus = optIn
      ? AdTargetingStatusParams.OPT_IN
      : AdTargetingStatusParams.OPT_OUT;
    await clientServices.getPersonalizationServices().setAdTargetingStatus(adTargetingStatus);
    setGoogleAdPreferences(adTargetingStatus);
  };

  const onToggle = async () => {
    setLocalAdTargetingStatus(!toggleStatus);
    await setAuthenticatedAdTargetingStatus(!toggleStatus);
  };

  const { t } = useTranslation();
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div css={styles.container}>
        <h3 css={styles.title}>{t('adPreferencesScreen.personalizedAds')}</h3>
        <div css={styles.main}>
          <div>
            <p css={styles.body}>{t('adPreferencesScreen.body1')}</p>
            <br />
            <p css={styles.body}>{t('adPreferencesScreen.body2')}</p>
          </div>
          <div css={styles.btnWrapper}>
            <Toggle toggleEnabled={!isIneligible} toggleOn={toggleStatus} onToggle={onToggle} />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AdPreferencesModal;
